import {AdxAlertRule, isAdxRule, isPriceRule, PriceAlertRule, TradingAlertRule} from "../models/rules/TradingAlertRule";
import {IFilterService} from "angular";
import {DollarOrPointsFilter} from "./DollarOrPointsFilter";
import {TradingAlert} from "../models/alert/TradingAlert";

export const RuleDisplay = "ruleDisplay";

export type RuleDisplayFilter = (rule: TradingAlertRule) => string;

function formatPriceRule(rule: PriceAlertRule, alert: TradingAlert, priceFilter: DollarOrPointsFilter): string {
    if (rule.priceBelow != null) {
        return `Price Below ${priceFilter(rule.priceBelow, alert)}`;
    } else if (rule.priceAbove != null) {
        return `Price Above ${priceFilter(rule.priceAbove, alert)}`;
    } else if (rule.pricePercentMove != null) {
        return `Price Move of ${rule.pricePercentMove}%`;
    } else {
        return "";
    }
}

function formatAdxRule(rule: AdxAlertRule) {
    if (rule.adxBelow != null) {
        return `ADX Below ${rule.adxBelow}`;
    } else if (rule.adxAbove != null) {
        return `ADX Above ${rule.adxAbove}`;
    } else {
        return "";
    }
}

/** @ngInject */
export function ruleDisplay($filter: IFilterService) {
    const priceFilter: DollarOrPointsFilter = $filter("dollarOrPoints");
    return (rule: TradingAlertRule, alert: TradingAlert) => {
        if (isPriceRule(rule)) {
            return formatPriceRule(rule, alert, priceFilter);
        } else if (isAdxRule(rule)) {
            return formatAdxRule(rule);
        } else {
            throw Error("Unsupported Rule Type");
        }
    };
}
